import BrowserActions from 'actions/BrowserActions';
import BrowserStore from 'stores/BrowserStore';
import dayjs from 'dayjs';
import AuthActions from 'actions/AuthActions';
import React from 'react';
import throttle from 'lodash/throttle';

// If a user is inactive (hasn't moved their mouse) for more than 180 minutes we log them out automatically.
const MAX_IDLE_TIME_INTERVAL = 180 * 60 * 1000; // 180 minutes
// Interval between checking if the user has made use of the site.
const LOGOUT_CHECK_INTERVAL = 30 * 1000; // 30 seconds

/**
 * Log out user if they weren't active in the last MAX_IDLE_TIME_INTERVAL milliseconds
 */
function logoutIfUserInactive() {
  const lastActiveDate = BrowserStore.getState()['lastActive'];
  if (lastActiveDate <= dayjs().subtract(MAX_IDLE_TIME_INTERVAL, 'milliseconds')) {
    AuthActions.logout({
      nextPathname: '/loggedOutWindow',
      message: 'Your session has expired.',
    });
  }
}

// Throttle mouse event to 1 sec
const onMouseMove = throttle(BrowserActions.setLastActive, 1000);

export default class AuthRefresh extends React.Component {
  logoutCheckInterval: ReturnType<typeof setInterval>;
  componentDidMount() {
    // Update user last active date on mouse move
    window.addEventListener('mousemove', onMouseMove);
    // Repeatedly check if the user has been idle for too long
    this.logoutCheckInterval = setInterval(logoutIfUserInactive, LOGOUT_CHECK_INTERVAL);
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', onMouseMove);
    clearInterval(this.logoutCheckInterval);
  }

  render() {
    return null;
  }
}
